import React from 'react'
import { ModalProvider,ConnectButton } from '@particle-network/connect-react-ui';
// import {  } from '@particle-network/connect-react-ui';
import { WalletEntryPosition } from '@particle-network/auth';
import { Ethereum, EthereumGoerli, BNBChain,BNBChainTestnet } from '@particle-network/chains';
import { evmWallets } from '@particle-network/connect';
import '@particle-network/connect-react-ui/dist/index.css';
// import { ConnectButton } from '@particle-network/connect-react-ui';

// use react kit
// let root=document.querySelector("#root");

console.log(React)
// console.log(ModalProvider)
// console.log(WalletEntryPosition)
// console.log(Ethereum)
// console.log(EthereumGoerli)
console.log(evmWallets)
// console.log(root)
// console.log(Ethereum)

function reactComponent() {//props
  // const { message } = props

  return (
  <div>
	<ModalProvider
		options={{
			projectId: 'd581ef80-0ecb-4a78-a938-f54244310c15',
			clientKey: 'cUKEgfafyiTlRofLwFizny92VTlv2NINnTIV9xQd',
			appId: 'cc6aff58-b5c0-4530-82f3-561e950d4671',
			chains: [
				Ethereum,
				EthereumGoerli,
				BNBChain,
				BNBChainTestnet
			],
			particleWalletEntry: {    //optional: particle wallet config
				displayWalletEntry: true, //display wallet button when connect particle success.
				defaultWalletEntryPosition: WalletEntryPosition.BR,
				supportChains:[
					Ethereum,
					EthereumGoerli,
					BNBChain,
					BNBChainTestnet
				],
				customStyle: {}, //optional: custom wallet style
			},
			securityAccount: { //optional: particle security account config
				//prompt set payment password. 0: None, 1: Once(default), 2: Always
				promptSettingWhenSign: 1,
				//prompt set master password. 0: None(default), 1: Once, 2: Always
				promptMasterPasswordSettingWhenLogin: 1
			},
			wallets: evmWallets({ 
				projectId: '2d26d2791835fc9543be494ad5fa5585', //replace with walletconnect projectId
				showQrModal: false
			}),
		}}
		theme={'auto'}
		language={'zh-CN'}   //optional：localize, default en
		walletSort={['Particle Auth', 'Wallet']} //optional：walelt order
		particleAuthSort={[    //optional：display particle auth items and order
		'email',
		'phone',
		'google',
		'apple',
		'facebook'
		]}
	>
	<ConnectButton />
	</ModalProvider>
	
	</div>
    // <div>
    //   <h2>{ message }</h2>
    // </div>
  )
}

export default reactComponent